import { ChevronDownIcon, Cog8ToothIcon, MinusIcon, CheckBadgeIcon } from "@heroicons/react/20/solid";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Actions as ZKTECO_ACTIONS } from "./store/zktecoActions";

import Logo from "./assets/zkteco-icon.svg";

import { useEffect, useState } from "react";
import IntegrationPunchClock from "../IntegrationPunchClock";
const unfinished = false;

const ZktecoSettings = ({
	connected,
	needsVerification,
	connect,
	disconnect,
	disabled,
	getPunchClocks,
	punchClocks,
	loading,
	saving,
	updateZKTecoPunchClocks,
}) => {
	const { register, handleSubmit, control } = useForm();

	const [expand, setExpand] = useState(false);
	const [connecting, setConnecting] = useState(false);
	const [serialNumber, setSerialNumber] = useState("");

	useEffect(() => {
		if (expand) getPunchClocks();
	}, [expand]);

	if (!connected) {
		return (
			<div className="col-xs-12 integration-row">
				<div className="col-xs-3">
					<div className="pull-left">
						<img
							src={Logo}
							width="40px"
						/>
						<span style={{ paddingLeft: 20, fontSize: 16 }}>ZK Teco</span>
					</div>
				</div>
				<div className="col-xs-9">
					{connecting ? (
						<form>
							<button
								type="button"
								className="btn btn-success pull-right"
								disabled={!serialNumber}
								onClick={() => connect(serialNumber)}
							>
								<CheckBadgeIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Connect</div>
							</button>
							<div className="col-xs-3 form-container pull-right">
								<div className="form-material">
									<input
										className="form-control"
										type="text"
										autoComplete="off"
										id="serialNumber"
										name="id"
										value={serialNumber}
										onChange={(e) => {
											const value = String(e.target.value);

											setSerialNumber(value);
										}}
									/>
									<label htmlFor="id">Serial Number</label>
									<div className="clearfix" />
								</div>
								<div className="clearix" />
							</div>
						</form>
					) : (
						<a
							className="btn btn-primary pull-right"
							onClick={() => setConnecting(true)}
						>
							Connect
						</a>
					)}
				</div>
			</div>
		);
	}

	return (
		<div className={`${expand ? "tr-gray" : ""} col-xs-12 integration-row`}>
			<div className="col-xs-3">
				<div className="pull-left">
					<img
						src={Logo}
						width="40px"
					/>
					<span style={{ paddingLeft: 20, fontSize: 16 }}>ZK Teco</span>
				</div>
			</div>
			<div className="col-xs-9">
				<div
					className="btn btn-default pull-right"
					style={{ paddingRight: 6 }}
					onClick={() => setExpand(!expand)}
				>
					<Cog8ToothIcon
						style={{
							height: "1.5em",
							float: "left",
							transform: expand ? "rotate(180deg)" : "rotate(0deg)",
							transition: "transform 0.5s ease-in-out",
						}}
					/>
					<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Settings</div>
					<ChevronDownIcon
						style={{
							height: "1.5em",
							float: "left",
							transform: expand ? "rotateX(180deg)" : "rotateX(0deg)",
							transition: "transform 0.3s ease-in-out",
						}}
					/>
				</div>
				<div
					className="btn btn-default pull-right"
					style={{ marginRight: 10 }}
				>
					{!loading ? (
						<div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
					) : <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Loading...</div>}
					
				</div>
			</div>
			<div className="col-xs-12">
				{expand ? (
					<>
						{/* <div
							className="row"
							style={{ padding: 0, paddingRight: "1.5rem" }}
							//onClick={} TODO
						>
							<button className="btn btn-primary pull-right">
								<MinusIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
							</button>
						</div> */}
						{!loading ? (
							<IntegrationPunchClock
								punchClocks={punchClocks}
								saving={saving}
								updatePunchClocks={(data, finalClock) => {
									updateZKTecoPunchClocks(data, finalClock);
								}} />
						) : null}
					</>
				) : null}
			</div>
		</div>
	);
};

const NotConnectedPrompt = ({ connected, disconnect, connect }) => {
	if (unfinished) {
		return <div className="btn btn-default pull-right">Coming Soon</div>;
	} else {
	}
};

const mapStateToProps = (state) => {
	const { zkTeco } = state?.integration?.timeAttendance || {};

	return {
		connected: !!zkTeco,
		punchClocks: zkTeco?.punchClocks,
		loading: zkTeco?.loading,
		saving: zkTeco?.saving,
	};
};

const mapDispatchToProps = (dispatch) => ({
	connect: (serialNumber) => dispatch(ZKTECO_ACTIONS.connectZKTeco(serialNumber)),
	getPunchClocks: () => dispatch(ZKTECO_ACTIONS.getZKTecoPunchClocks()),
	updateZKTecoPunchClocks: (data, finalClock) => dispatch(ZKTECO_ACTIONS.updateZKTecoPunchClocks(data, finalClock)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ZktecoSettings);
